import { supportedKeySystems } from '../settings/settings.user-agent';
export function isFairPlayDrmSupported(keySystems) {
    return keySystems.some((keySystem) => window.WebKitMediaKeys?.isTypeSupported(keySystem, 'video/mp4'));
}
export const isSafariUserAgent = (userAgent) => userAgent.includes('Safari') &&
    !userAgent.includes('Chrome') &&
    !userAgent.includes('IEMobile') &&
    !userAgent.includes('Edge') &&
    !userAgent.includes('Chromium') &&
    !userAgent.includes('Android');
export function isSafari() {
    return isSafariUserAgent(navigator.userAgent) || isFairPlayDrmSupported(supportedKeySystems);
}
